var _mask, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 126 48",
    width: 126,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 47.473434h126v-47.47303h-126z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#111",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66.2476 16.267767c-1.057-.8888-2.861-1.3332-5.413-1.3332h-5.756v17.78812h4.304v-5.57419h1.928c2.34 0 4.056-.5151 5.148-1.54631 1.231-1.15544 1.849-2.69367 1.849-4.61368 0-1.99071-.687-3.56429-2.06-4.72074m-5.044 6.85487h-1.821v-4.1612h1.636c1.99 0 2.985.69791 2.985 2.09373 0 1.37764-.934 2.06747-2.8 2.06747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.6734 14.934264h-4.488v17.78812h9.69v-4.02687h-5.202z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.6676 14.934264-7.05 17.78812h4.832l.924-2.58661h6.126l.845 2.58661h4.886l-6.999-17.78812zm-.053 11.60086 1.849-6.0802 1.821 6.0802z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.473 32.722384h4.489v-17.78812h-4.489z",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.3892 18.268072c-.599-.85345-1.312-1.53722-2.139-2.05333-1.355-.85345-3.204-1.28068-5.545-1.28068h-5.914v17.78812h6.918c2.499 0 4.506-.81709 6.02-2.45329 1.514-1.63519 2.27-3.80467 2.27-6.50743 0-2.15029-.537-3.98142-1.61-5.49339m-7.182 10.42724h-1.927v-9.73438h1.954c1.373 0 2.428.42925 3.168 1.28674.739.85749 1.109 2.07353 1.109 3.64711 0 3.20069-1.434 4.80053-4.304 4.80053",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.6373.000202-14.548 3.80972-4.008 14.62884 5.014 5.14797-5.096 5.06313 3.773 14.69348 14.484 4.04707 5.096-5.06414 5.014 5.14696 14.547-3.80972 4.008-14.63086-5.013-5.14595 5.095-5.06313-3.772-14.69348-14.486-4.04707-5.094 5.06313zm-8.928 6.62358 7.663-2.00788 3.351 3.44006-4.887 4.85608zm16.822 1.47864 3.405-3.3835 7.63 2.13211-6.227 6.18726zm-21.859 9.13545 2.111-7.70529 6.125 6.28826-4.886 4.85608zm29.547-1.24331 6.227-6.18827 1.986 7.74064-3.404 3.3835zm-15.502-.12625 4.887-4.85608 4.807 4.93587-4.886 4.85608zm-7.814 7.76488 4.886-4.85608 4.809 4.93587-4.887 4.85608zm15.503.12726 4.886-4.85608 4.808 4.93587-4.887 4.85608zm-21.836 6.16605 3.406-3.38451 4.807 4.93688-6.225 6.18625zm14.021 1.59883 4.887-4.85608 4.808 4.93587-4.886 4.85608zm15.502.12726 4.887-4.85608 3.351 3.43905-2.111 7.70529zm-24.656 8.96981 6.226-6.18827 4.809 4.93587-3.405 3.38451zm16.843-1.20493 4.886-4.85608 6.126 6.28826-7.662 2.00687z",
    mask: "url(#a)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaid);
export default __webpack_public_path__ + "static/media/plaid.7f468338f51d189cb169eb1f5fb4de7c.svg";
export { ForwardRef as ReactComponent };